import { render, staticRenderFns } from "./NotCert.vue?vue&type=template&id=2339a75b&"
import script from "./NotCert.vue?vue&type=script&lang=ts&"
export * from "./NotCert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports